import { Component, ViewEncapsulation, ViewChild, TemplateRef, ElementRef, OnInit } from '@angular/core';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { AppService } from '../../app.service';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SuccessSnackbarComponent } from '../../support/success-snackbar/success-snackbar.component';
import { PaginationService } from '../../PaginationService';
import { messageService } from '../../message.service';
import { DynamicAuditTrailComponent } from '../../support/dynamic-audit-trail/dynamic-audit-trail.component';
import { ExcelPdfComponent } from '../../support/excel-pdf/excel-pdf.component';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import { GridReorderComponent } from '../../grid-reorder/grid-reorder.component';

@Component({
  selector: 'app-codelist',
  templateUrl: './codelist.component.html',
  styleUrls: ['./codelist.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class CodelistComponent implements OnInit {
  isProcessing = false;
  visibleMandatorySymbols: boolean;
  columnname: any;
  _temp: any = {};
  columnLists: any = {};
  oneQmsUsersDataForTable1: any = [];
  addpopopData: any;
  userprivData: any = {};
  nonorgModulesData: any;
  dropDownForDesignationCode: any;
  dropDownForDepartmentCode: any;
  dropDownForPrimaryLanguage: any;
  dropDownForSecondaryLanguage: any;
  dropDownForCountry: any;
  dropDownForTimezone: any;
  dropDownForSearchByStatus: any;
  TrainingCategorySubgroups: any;
  oneQmsUsersDataForTable1Temp: any;
  dataTypeList: any = [];
  array: any = [];
  oneQmsOrgUsersDetails: any;
  searchText: any;
  showUserSearchGrid: boolean;
  searchByUserName: any = null;
  searchByFirstName: any = null;
  searchByLastName: any = null;
  searchByDesignationCode: any = [];
  searchByDepartmentCode: any = [];
  searchingByStatusCode: any = [];
  designationCodeValue: any;
  departmentCodeValue: any;
  statusCodeValue: any;
  searchOneQmsUserVwDetails: any;
  getOneQmsUsersVwDetailsTableData: any = [];
  visibleDataGrid: boolean = false;
  itemsPerPage = 5; // Number of items to display per page
  currentPage = 1; // Current page number
  totalPages = 0; // Total number of pages
  showCodeForIdGeneration: boolean = false;
  showsubgroupName: boolean = false;
  showsubgroupValues: boolean = false;
  subgroupValueList: any;
  subgroupValueDropdown: any = [];
  oddGroupName: any = null;
  oddModule: any = null;

  auditTrail: any = {};
  visibleAuditTrail: boolean = false;

  constructor(public dialog: MatDialog, private readonly appService: AppService, public router: Router, private readonly snackBar: MatSnackBar,
    public paginationService: PaginationService, public message: messageService, private readonly elem: ElementRef) { }

  singleSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: false,
    allowSearchFilter: true,
    singleSelection: true,
    itemsShowLimit: 1,
    closeDropDownOnSelection: true,
  };

  multipleSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: true,
    allowSearchFilter: true,
  };

  selectedDesignationValue: any;
  designationCodeDropdown: any = [];
  codelistGroupList: any = [];
  searchValue: any;
  maxSize = 3;
  collectionSize: number;
  perPage = 10;
  calculateTotalPages: number;
  showingResultsText = "Showing results";
  displayingClaimsText = "Displaying claims";
  rowText = "Rows";
  showingRowsText = "Showing rows";
  private readonly users: any[];
  pager: any = {};
  pagedItems: any[];
  error = '';
  setPage(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }
    this.pager = this.paginationService.getPager(this.oneQmsUsersDataForTable1.length, page, this.perPage, targetpage);
    this.pagedItems = this.oneQmsUsersDataForTable1.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }

  oneQmsUsersDataForFilter !: any[];
  dropDownDataForModule: any = [];
  makeStickyColumns: any;

  refreshGridData() {
    this.getcallMethod();
  }
  focusEmpty() {
    console.log();
  }

  ngOnInit() {
    this.isProcessing = true;
    this.dropDownDataForModule = JSON.parse(sessionStorage.getItem('dropDownForModules') || '{}');
    this.selectBoxForModule();
    this.appService.getdistinctCodeListsGroup(this.selectedMainModule ?? undefined).subscribe((response: any) => {
      this.codelistGroupList = response;
      this.selectBoxeForDesignationCode();
      this.isProcessing = false;
    });
  }

  selectBoxeForDesignationCode() {
    this.designationCodeDropdown = [];
    this.designationCodeDropdown = this.designationCodeDropdown.concat({
      valueExp: "All",
      displayExp: "All"
    });
    this.codelistGroupList.sort((a: any, b: any) => a.codelistsPk.groupName?.localeCompare(b.codelistsPk.groupName));
    for (const codelistGroup of this.codelistGroupList) {
      this.designationCodeDropdown.push({
        valueExp: codelistGroup.codelistsPk.groupName,
        displayExp: codelistGroup.codelistsPk.groupName
      });
    }
  }

  selectBoxeForsubgroupValue() {
    this.subgroupValueDropdown = [];
    for (const subgroup of this.subgroupList) {
      this.subgroupValueDropdown.push({
        valueExp: subgroup.codelistName,
        displayExp: subgroup.codelistName
      });
    }
  }
  searchingByUserName: any = null;
  searchingByFirstName: any = null;
  searchingByLastName: any = null;
  searchingByDesignationCode: any = null;
  searchingByDepartmentCode: any = [];
  gridResetFunction() {
    this.selectedMainModule = null;
    this.searchingByDesignationCode = null;
    this.pagedItems = [];
    this.pager = {};
    this.visibleDataGrid = false;
  }


  paginationCall(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  }

  getcallMethod() {
    this.isProcessing = true;
    setTimeout(() => {
      this.isProcessing = false;
    }, 3000);
    this.designationCodeValue = null;
    this.departmentCodeValue = null;
    this.statusCodeValue = null;
    this.oneQmsUsersDataForTable1 = [];
    const data = {

      gridName: "CODELISTS"
    }
    this.appService.getDynamicGridHeaders(data).subscribe({
      next: (response: any) => {
        response.orderByClause ??= "";
        this.makeStickyColumns = response.fixedFieldCnt;
        let formattedUserName = null;
        if (this.searchingByUserName) {
          formattedUserName = this.searchingByUserName.toUpperCase();
        }
        const data1: any = {

          gridName: "CODELISTS",
          tableOrViewName: response.tableOrViewName ?? "",
          columnsList: response.columnsList ?? "",
          fieldLabelsList: response.fieldLabelsList ?? "",
          invisibleColumn: response.invisibleColumn ?? "",
          orderByClause: response.orderByClause ?? "",
          fieldSizeList: response.fieldSizeList ?? "",
          columnsListarray: [],
          fieldColumnarray: [],
          invisibleColumnarray: [],
          fieldSizeListArray: [],
          userName: formattedUserName,
          firstName: this.searchingByFirstName == "" ? null : this.searchingByFirstName,
          lastName: this.searchingByLastName == "" ? null : this.searchingByLastName,
          designationCode: this.designationCodeValue,
          departmentCode: this.departmentCodeValue,
          status: this.statusCodeValue,
          codelistGroup: null,
          manualEntryDataFields: response.manualEntryDataFields
        }
        if (this.searchingByDesignationCode) {
          data1.codelistGroup = this.searchingByDesignationCode;
        } else {
          data1.codelistGroup = null;
        }
        data1.moduleList = "noModule";
        if (this.selectedMainModule) {
          data1.moduleList = this.selectedMainModule;
        } else {
          data1.moduleList = "noModule";
        }
        this.reportObj = { ...data1, ...data };
        this.auditTrail.secondary_obj = data1;
        this.appService.getDynamicGridData(data1).subscribe({
          next: (response1: any) => {
            this.oneQmsUsersDataForTable1 = response1;
            this.visibleAuditTrail = false;
            data1.columnsListarray = data1.columnsList.split(",");
            data1.fieldColumnarray = data1.fieldLabelsList.split(",");
            data1.invisibleColumnarray = data1.invisibleColumn.split(",");
            data1.fieldSizeListArray = data1.fieldSizeList.split(",");
            this.columnLists.columnsListarray = data1.columnsListarray;
            this.columnLists.fieldLabelsList = data1.fieldLabelsList;
            this.columnLists.fieldColumnarray = [];
            for (let p = 0; p < data1.fieldColumnarray.length; p++) {
              this.columnLists.fieldColumnarray.push({
                "fieldColumnarray": data1.fieldColumnarray[p],
                "width": data1.fieldSizeListArray[p] + 'px'
              })
            }
            this.columnLists.invisibleColumnarray = data1.invisibleColumnarray;
            this.columnLists.fieldSizeListArray = [];
            for (const size of data1.fieldSizeListArray) {
              this.columnLists.fieldSizeListArray.push(size + 'px');
            }

            for (const invisibleCol of this.columnLists.invisibleColumnarray) {
              const index = this.columnLists.columnsListarray.indexOf(invisibleCol);

              if (index !== -1) {
                this.columnLists.columnsListarray.splice(index, 1);
                this.columnLists.fieldColumnarray.splice(index, 1);
                this.columnLists.fieldSizeListArray.splice(index, 1);
              }
            }
            let tableData = {
              tablename: data1.tableOrViewName
            };
            this.columnLists.columnsListarray1 = [];
            this.appService.tableFieldsDataType(tableData).subscribe((response2: any) => {
              this.dataTypeList = response2;
              for (let m = 0; m < this.columnLists.columnsListarray.length; m++) {
                this.columnLists.columnsListarray1.push({});
                this.columnLists.columnsListarray1[m].columnsListarray = this.columnLists.columnsListarray[m];
                this.columnLists.columnsListarray1[m].dataType = "textbox";
                this.columnLists.columnsListarray1[m].width = this.columnLists.fieldSizeListArray;
                for (const dataType of this.dataTypeList) {
                  if (dataType.columnName === this.columnLists.columnsListarray[m]) {
                    this.columnLists.columnsListarray1[m].dataType = dataType.fieldType;
                  }
                }
              }
              for (const userData of this.oneQmsUsersDataForTable1) {
                for (const dataType of this.dataTypeList) {
                  if (dataType.fieldType === 'CHECKBOX') {
                    userData[dataType.columnName] = userData[dataType.columnName] === "Y";
                  }
                }
              }
              this.calculateTotalPages = this.collectionSize / this.perPage;
              this.pager.totalPages = undefined;
              this.setPage(1, 0);
              this.labelcall()
            });
            this.message.gridList = this.oneQmsUsersDataForTable1;
            this.collectionSize = this.oneQmsUsersDataForTable1.length;
            this.totalPages = Math.ceil(this.oneQmsUsersDataForTable1.length / this.itemsPerPage);
          }, error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });
        this.isProcessing = false;
      }, error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });
    this.visibleDataGrid = true;
  }

  label: any = [];
  dynamicLabel: any = null;
  labelcall() {
    this.isProcessing = true;
    let data = {
      tableName: this.reportObj.tableOrViewName,
      moduleName: null,
      gridName: this.reportObj.gridName,
      groupId: 0
    };
    this.appService.getreorderGirdColumnList(data).subscribe({
      next: (data: any) => {
        this.label = data;
        this.dynamicLabel = this.label.reduce((acc: any, user: any) => {
          acc[`${user.columnName}`] = user.changedFieldName;
          return acc;
        }, {});
        this.isProcessing = false;
      }, error: (error: any) => {
        this.isProcessing = false;
      }
    });
  }
  applyFilter3(column: string, event: Event): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.pagedItems = this.oneQmsUsersDataForTable1.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = this.oneQmsUsersDataForTable1.filter((item: any) =>
        item[column]?.toLowerCase().includes(filter)
      );
    }
  }

  parentCheckBox: boolean = false;
  childCheckBoxs: boolean = false;
  dataGridParentCheckBoxChecked(e: any) {
    const isChecked = e.target.checked;
    this.childCheckBoxs = isChecked;

    for (const user of this.oneQmsUsersDataForTable1) {
      user.childCheckBoxs = isChecked;
    }
  }

  previousIdx: any;
  dataGridChildCheckBoxChecked(e: any, list: any, idx: any) {
    if (e.target.checked) {
      if (this.previousIdx != undefined) {
        this.oneQmsUsersDataForTable1[this.previousIdx].childCheckBoxs = false;
      }
      list.childCheckBoxs = true;
      this.auditTrail.refNo = list.CODELIST_CODE;
    } else {
      list.childCheckBoxs = false;
    }
    this.visibleAuditTrail = this.oneQmsUsersDataForTable1.some((list: any) => list.childCheckBoxs);
    this.previousIdx = idx;
  }

  /* End Multi Row Select */

  searchManagerParentCheckBox: boolean = false;
  searchManagerChildCheckBoxs: boolean = false;
  searchManagerChildCheckBoxsMenu: boolean = false;
  searchManagerDataGridParentCheckBoxChecked(e: any) {
    const isChecked = e.target.checked;

    for (const rowData of this.getOneQmsUsersVwDetailsTableData) {
      rowData.searchManagerChildCheckBoxs = isChecked;
    }
  }

  getSelectedUserId: any;
  getSelectedUserName: string;
  searchManagerChildCheckBoxChecked(e: any, listOfUsersVwDetails: any, idx: any) {
    if (e.target.checked) {
      listOfUsersVwDetails.searchManagerChildCheckBoxs = true;
      this.getSelectedUserId = listOfUsersVwDetails.userId;
      this.getSelectedUserName = listOfUsersVwDetails.userName;
    } else {
      listOfUsersVwDetails.searchManagerChildCheckBoxs = false;
      this.getSelectedUserId = null;
      this.getSelectedUserName = '';
    }
  }

  counts: any;
  cssfunction(ix: number) {
    let elements1 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-col1');
    let index1 = 1;
    let headerWidth = 0;
    elements1.forEach((header: any, key: any) => {
      for (let i = 1; i <= this.makeStickyColumns; i++) {
        if (index1 == i) {
          header.style.position = 'sticky';
          header.style.background = 'white';
          if (index1 > 1) {
            headerWidth += 200;
            header.style.left = headerWidth + 'px';
          } else {
            headerWidth = 60;
            header.style.left = headerWidth + 'px';
          }
        }
      }
      index1++;
    })

    let elements2 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-row1');
    let index2 = 1;
    let lengthOfColumns = this.columnLists.columnsListarray1.length;
    let colWidth = 0;
    let p = 1;
    elements2.forEach((column: any, key: any) => {
      for (let j = 1; j <= this.makeStickyColumns; j++) {
        if (index2 == j) {
          column.style.position = 'sticky';
          p = p + 1;
          column.style.background = 'white';
          if (index2 > 1) {
            colWidth += 200;
            column.style.left = colWidth + 'px';
          } else {
            colWidth = 60;
            column.style.left = colWidth + 'px';
          }
          column.addEventListener('click', this.onClick.bind(this));
        }
      }
      if (index2 == (lengthOfColumns - 1)) {
        index2 = 0;
      } else {
        index2++;
      }
    })
  }

  onClick(event: any) {

  }

  popupTitle: string | null = 'Codelist';
  @ViewChild('addAndEditPopup', { static: true }) addAndEditPopup: TemplateRef<any>;
  visibleAddAndEditPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('deletePopup', { static: true }) deletePopup: TemplateRef<any>;
  visibleDeletePopup: MatDialogRef<TemplateRef<any>>;

  addAndEditPopupConfig = {
    width: '100%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '60px' },
  };

  deletePopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };

  inActiveUserFlag: boolean;
  activeUserFlag: boolean;
  visibleEditButton: boolean;
  codelistEditdata: any;
  showFieldsData = [];
  onDesignationCodeRemoved(item: any) {
    this.selectSubgroupValue = [];
    this.showCodeForIdGeneration = false;
    this.showsubgroupName = false;
    this.visibleDataGrid = false;
    this.codelistEditdata.codeForIdGeneration = null;
    this.codelistEditdata.subgroupName = null;
  };

  designationsearchTxt: any;
  groupNamesearchTxt: any;
  onDesignationCodeSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (event.source._selected) {
        this.isProcessing = true;
        if (item) {
          this.isProcessing = true;
          this.selectedDesignationValue = item.valueExp;
          if (this.codelistEditdata) {
            this.codelistEditdata.codelistsPk.groupName = item.valueExp;
            this.isProcessing = false;
            this.appService.getCodeListsByGroup(item.valueExp).subscribe((response: any) => {
              this.showFieldsData = response;
              this.showCodeForIdGeneration = false;
              this.showsubgroupName = false;
              for (const item of response) {
                if (item.codeForIdGeneration !== null) {
                  this.codelistEditdata.codeForIdGeneration = item.codeForIdGeneration;
                  this.showCodeForIdGeneration = true;
                }

                if (item.subgroupName !== null) {
                  this.codelistEditdata.subgroupName = item.subgroupName;
                  this.selectSubgroupValue = [];
                  this.showsubgroupName = true;

                  if (item.subgroupName == "Functional Areas") {
                    this.appService.getCodeListsByGroup(
                      'AUDIT_DEPARTMENT_FUNCTIONAL_AREAS'
                    ).subscribe((data: any) => {
                      this.selectBoxeForsubgroupValue();
                    });
                  } else {
                    this.appService.getNonOrgCodeListsByGroupName(

                      this.codelistEditdata.codelistsPk.groupName + "_SUBGROUP"
                    ).subscribe((res: any) => {
                      this.selectBoxeForsubgroupValue();
                    });
                  }
                }
              }
              this.isProcessing = false;
            });
          } else {
            setTimeout(() => {
              this.getcallMethod();
            }, 0);
            this.isProcessing = false;
          }
        } else {
          this.isProcessing = false;
          this.selectSubgroupValue = [];
          this.showCodeForIdGeneration = false;
          this.showsubgroupName = false;
          this.visibleDataGrid = false;
          this.codelistEditdata.codeForIdGeneration = null;
          this.codelistEditdata.subgroupName = null;
        }

      } else {
        this.selectedDesignationValue = undefined;
        this.isProcessing = false;
      }

    }

  }
  @ViewChild('subGroupValue') subGroupValue: MatSelect;
  isSubGroupValueSelected = false;

  subGroupValueSearchText: any;
  toggleAllSelection(value: any) {
    if (value == 'subGroupValue') {
      if (this.isSubGroupValueSelected) this.subGroupValue.options.forEach((item: MatOption) => item.select());
      else this.subGroupValue.options.forEach((item: MatOption) => item.deselect());
    }

  }


  onGroupvalueSelect(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => { this.isSubGroupValueSelected = this.subgroupValueDropdown.length == this.selectSubgroupValue.length; })
    }
  }
  onGroupvalueRemoved(item: any) { };

  selectgroupName: any;
  selectSubgroupValue: any = [];
  subgroupList: any;
  showGroupDropDown: boolean;
  openAddPopup() {
    this.isProcessing = true;
    this.codelistEditdata = {
      "codelistsPk": {
        codelistCode: null,
        groupName: null
      },
      isActive: false,

    }


    if (this.selectedMainModule) {
      this.selectBoxForModule();
      const matchingModule = this.dropDownDataForModule?.find((item: any) => item.codelistCode == this.selectedMainModule);
      if (!matchingModule && this.selectedMainModule != 'Common') {
        this.oddModule = this.selectedMainModule;
        this.moduleListDropdown.push({
          valueExp: this.selectedMainModule,
          displayExp: this.selectedMainModule
        })
      }
      this.selectedModule = this.selectedMainModule;
    }

    if (this.searchingByDesignationCode) {
      this.showGroupDropDown = true;
      this.codelistEditdata.codelistsPk.groupName = this.searchingByDesignationCode;
      if (this.searchingByDesignationCode == "All") {
        this.showGroupDropDown = false;
        this.codelistEditdata.codelistsPk.groupName = null;
      }

      this.selectgroupName = this.searchingByDesignationCode;
      this.visibleMandatorySymbols = true;
      this.appService.getCodeListsByGroup(this.searchingByDesignationCode).subscribe((response: any) => {
        this.showFieldsData = response;
        this.showCodeForIdGeneration = false;
        this.showsubgroupName = false;
        for (const item of response) {
          if (item.codeForIdGeneration !== null) {
            this.codelistEditdata.codeForIdGeneration = item.codeForIdGeneration;
            this.showCodeForIdGeneration = true;
          }

          if (item.subgroupName !== null) {
            this.codelistEditdata.subgroupName = item.subgroupName;
            this.selectSubgroupValue = [];

            // Updated to strict equality (===)
            setTimeout(() => {
              this.isSubGroupValueSelected = this.subgroupValueDropdown.length === this.selectSubgroupValue.length;
            });

            this.showsubgroupName = true;

            if (item.subgroupName === "Functional Areas") {
              this.appService.getCodeListsByGroup('AUDIT_DEPARTMENT_FUNCTIONAL_AREAS').subscribe((data: any) => {
                this.subgroupList = data;
                this.selectBoxeForsubgroupValue();
              });
            } else {
              this.appService.getNonOrgCodeListsByGroupName(

                this.codelistEditdata.codelistsPk.groupName + "_SUBGROUP"
              ).subscribe((res: any) => {
                this.subgroupList = res;
                this.selectBoxeForsubgroupValue();
              });
            }
          }
        }
        this.isProcessing = false;
      });
    } else {
      this.visibleMandatorySymbols = true;
      this.showGroupDropDown = false;
      this.showCodeForIdGeneration = false;
      this.showsubgroupName = false;
      this.selectgroupName = null;
      this.isProcessing = false;
    }
    this.visibleEditButton = false;
    this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
  }

  previousData: any;
  filteredModuleValue: any;
  openEditPopup(data: any) {
    this.previousData = data;
    this.showGroupDropDown = true;
    this.isProcessing = true;
    this.showCodeForIdGeneration = false;
    this.showsubgroupName = false;
    this.visibleMandatorySymbols = false;
    this.codelistEditdata = {
      "codelistsPk": {
        codelistCode: data.CODELIST_CODE,
        groupName: data.GROUP_NAME,
      },
      codeForIdGeneration: data.CODE_FOR_ID_GENERATION,
      codelistName: data.CODELIST_NAME,
      comments: data.COMMENTS,
      isActive: data.IS_ACTIVE,
      subgroupName: data.SUBGROUP_NAME,
      subgroupValues: data.SUBGROUP_VALUES,
      moduleList: data.MODULE_LIST,
      updateReason: null,

    };
    if (this.codelistEditdata.codelistsPk.groupName) {
      const matchingSourceGroupName = this.codelistGroupList?.find((item: any) => item.codelistsPk.groupName == this.codelistEditdata.codelistsPk.groupName);
      if (!matchingSourceGroupName) {
        this.oddGroupName = this.codelistEditdata.codelistsPk.groupName;
        this.designationCodeDropdown.push({
          valueExp: this.codelistEditdata.codelistsPk.groupName,
          displayExp: this.codelistEditdata.codelistsPk.groupName
        })
      }
      this.selectgroupName = this.codelistEditdata.codelistsPk.groupName;
    }


    if (this.codelistEditdata.moduleList) {
      this.selectBoxForModule();
      const matchingModule = this.dropDownDataForModule?.find((item: any) => item.codelistCode == this.codelistEditdata.moduleList);
      if (!matchingModule && this.codelistEditdata.moduleList != 'Common') {
        this.oddModule = this.codelistEditdata.moduleList;
        this.moduleListDropdown.push({
          valueExp: this.codelistEditdata.moduleList,
          displayExp: this.codelistEditdata.moduleList
        })
      }
      this.selectedModule = this.codelistEditdata.moduleList;
    }
    this.appService.getCodeListsByGroup(this.codelistEditdata.codelistsPk.groupName).subscribe((response: any) => {
      this.isProcessing = false;
      this.showFieldsData = response;
      this.showCodeForIdGeneration = false;
      this.showsubgroupName = false;
      for (const item of response) {
        if (item.codeForIdGeneration !== null) {
          this.showCodeForIdGeneration = true;
        }

        if (item.subgroupName !== null) {
          this.showsubgroupName = true;
        }
      }
    });
    if (data.SUBGROUP_VALUES) {
      this.selectSubgroupValue = data.SUBGROUP_VALUES.split(',');
      setTimeout(() => { this.isSubGroupValueSelected = this.subgroupValueDropdown.length == this.selectSubgroupValue.length; })
    }

    if (this.codelistEditdata.subgroupName == "Functional Areas") {
      this.appService.getCodeListsByGroup('AUDIT_DEPARTMENT_FUNCTIONAL_AREAS').subscribe((data: any) => {
        this.subgroupList = data;
        this.selectBoxeForsubgroupValue();
      })
    } else {
      this.appService.getNonOrgCodeListsByGroupName(this.codelistEditdata.codelistsPk.groupName + "_SUBGROUP").subscribe((response: any) => {
        this.subgroupList = response;
        this.selectBoxeForsubgroupValue();
      });
    }
    this.visibleEditButton = true;
    this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
  }

  groupNameValue: any;
  codelistCodeValue: any;
  codeListNameValue: any;
  codeListNameRequiredMsg: any;
  inputGroupNameRequiredMsg: any;
  codelistCodeRequiredMsg: any;
  moduleValue: any;
  moduleRequiredMsg: any;
  fieldValidation() {
    this.moduleValue = document.getElementById('module') as HTMLInputElement;
    this.groupNameValue = document.getElementById('groupName') as HTMLInputElement;
    this.codelistCodeValue = document.getElementById('codelistCode') as HTMLInputElement;
    this.codeListNameValue = document.getElementById('codelistName') as HTMLInputElement;

    this.moduleRequiredMsg = document.getElementById('module-required-msg') as HTMLInputElement;
    this.inputGroupNameRequiredMsg = document.getElementById('inputGroupName-required-msg') as HTMLInputElement;
    this.codelistCodeRequiredMsg = document.getElementById('codelistCode-required-msg') as HTMLInputElement;
    this.codeListNameRequiredMsg = document.getElementById('codelistName-required-msg') as HTMLInputElement;

    if (this.selectedModule) {
      this.moduleValue.style.border = 'none';
      this.moduleRequiredMsg.style.display = 'none';
    } else {
      this.moduleValue.style.border = '1px solid red';
      this.moduleRequiredMsg.style.display = 'block';
    }
    if (!this.showGroupDropDown) {
      if (this.codelistEditdata.codelistsPk.groupName == null) {
        this.groupNameValue.style.border = '1px solid red';
        this.inputGroupNameRequiredMsg.style.display = 'block';
      } else {
        this.groupNameValue.style.border = 'none';
        this.inputGroupNameRequiredMsg.style.display = 'none';
      }
    }
    if (this.codelistEditdata.codelistsPk.codelistCode == null) {
      this.codelistCodeValue.style.border = '1px solid red';
      this.codelistCodeRequiredMsg.style.display = 'block';
    } else {
      this.codelistCodeValue.style.border = 'none';
      this.codelistCodeRequiredMsg.style.display = 'none';
    }
    if (this.codeListNameValue.value) {
      this.codeListNameValue.style.border = 'none';
      this.codeListNameRequiredMsg.style.display = 'none';
    } else {
      this.codeListNameValue.style.border = '1px solid red';
      this.codeListNameRequiredMsg.style.display = 'block';
    }
    this.isProcessing = false;
  }

  updateReasonValidation() {
    const updateReason = document.getElementById('updateReason') as HTMLInputElement;
    const updateReasonRequiredMsg = document.getElementById('updateReason-required-msg') as HTMLInputElement;
    if (this.codelistEditdata.updateReason == null) {
      updateReason.style.border = '1px solid red';
      updateReasonRequiredMsg.style.display = 'block';
    } else {
      updateReason.style.border = 'none';
      updateReasonRequiredMsg.style.display = 'none';
    }
  }

  addAndEditFunction(codeListdata: any) {
    this.isProcessing = true;
    this.codelistEditdata.codelistCode = this.codelistEditdata.codelistsPk.codelistCode;
    this.codelistEditdata.groupName = this.codelistEditdata.codelistsPk.groupName;
    if (!this.selectedModule || this.codelistEditdata.codelistsPk.groupName == null || this.codelistEditdata.codelistsPk.codelistCode == null || !this.codelistEditdata.codelistName) {
      this.fieldValidation();
      this.isProcessing = false;
    } else {
      let data = {
        ... this.codelistEditdata,
        moduleList: this.selectedModule,
        isActive: codeListdata.isActive ? "Y" : "N"
      }
      if (this.codelistEditdata.subgroupName == 'Watermark Color Code') {
        data.subgroupValues = this.codelistEditdata.subgroupValues;
      } else {
        data.subgroupValues = this.selectSubgroupValue.join(',');
      }

      if (this.visibleEditButton) {
        if (this.codelistEditdata.updateReason) {
          this.appService.updateCodelist(data).subscribe({
            next: (Response: any) => {
              if (Response.resultType == 'S') {
                this.visibleAddAndEditPopup.close();
                this.getcallMethod();
                this.ngOnInit();
              }
              this.isProcessing = false;
              let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
                duration: Response.resultType == 'S' ? 5000 : undefined,
                data: {
                  message: Response.result,
                  type: Response.resultType == 'S' ? 'Success' : 'Error',
                  buttonLabel: "Ok",
                  pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel
                },
                horizontalPosition: 'center',
                verticalPosition: 'top',
                panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
              });
              sb.onAction().subscribe(() => {
                sb.dismiss();
              });
              this.isProcessing = false;
            }, error: (error) => {
              this.isProcessing = false;
              throw error;
            }
          });
        } else {
          this.updateReasonValidation();
          this.isProcessing = false;
        }
      } else {
        this.appService.createCodelist(data).subscribe({
          next: (Response: any) => {
            if (Response.resultType == 'S') {
              this.visibleAddAndEditPopup.close();
              this.getcallMethod();
              this.ngOnInit();
            }
            this.isProcessing = false;
            let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
              duration: Response.resultType == 'S' ? 5000 : undefined,
              data: {
                message: Response.result,
                type: Response.resultType == 'S' ? 'Success' : 'Error',
                buttonLabel: "Ok",
                pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel
              },
              horizontalPosition: 'center',
              verticalPosition: 'top',
              panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
            });
            sb.onAction().subscribe(() => {
              sb.dismiss();
            });
            this.isProcessing = false;
          }, error: (error) => {

            this.isProcessing = false;
            throw error;
          }
        });
      }
    }
  };

  cancelAddAndEditFunction() { this.visibleAddAndEditPopup.close(); }

  deleteCodelist(data: any) {
    this.deleteReason = null;
    this.showCodeForIdGeneration = false;
    this.showsubgroupName = false;
    this.codelistEditdata = {

      codelistCode: data.CODELIST_CODE,
      groupName: data.GROUP_NAME,
      moduleList: data.MODULE_LIST,
      codeForIdGeneration: data.CODE_FOR_ID_GENERATION,
      codelistName: data.CODELIST_NAME,
      comments: data.COMMENTS,
      isActive: data.IS_ACTIVE,
      subgroupName: data.SUBGROUP_NAME,
      subgroupValues: data.SUBGROUP_VALUES,
      updateReason: null,

    };
    this.visibleDeletePopup = this.dialog.open(this.deletePopup, this.deletePopupConfig);
  }

  deleteReasonValue: any;
  deleteValidation() {
    const deleteReasonValue = document.getElementById('deleteReason') as HTMLInputElement;
    const deleteReasonRequiredMsg = document.getElementById('deleteReason-required-msg') as HTMLInputElement;
    if (this.codelistEditdata.updateReason == null) {
      deleteReasonValue.style.border = '1px solid red';
      deleteReasonRequiredMsg.style.display = 'block';
    } else {
      deleteReasonValue.style.border = 'none';
      deleteReasonRequiredMsg.style.display = 'none';
    }
  }

  deleteReason: any = null;
  deleteFunction() {
    if (this.deleteReason == null) {
      this.deleteValidation();
    } else {
      this.isProcessing = true;
      this.codelistEditdata.deleteReason = this.deleteReason;
      this.codelistEditdata.isActive = this.codelistEditdata.isActive ? "Y" : "N";
      this.appService.deleteCodelist(this.codelistEditdata).subscribe({
        next: (Response: any) => {
          if (Response.resultType == 'S') {
            this.visibleDeletePopup.close();
            this.getcallMethod();
            this.ngOnInit();
          }
          this.isProcessing = false;
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: Response.resultType == 'S' ? 5000 : undefined,
            data: {
              message: Response.result,
              type: Response.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok",
              pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
          this.isProcessing = false;
        }, error: (error) => {

          this.isProcessing = false;
          throw error;
        }
      });
    }
  }

  cancelDeleteFunction() {
    this.visibleDeletePopup.close();
  }

  selectedModule: any = null;
  selectedMainModule: any = null;
  moduleListDropdown: any = [];
  selectBoxForModule() {
    this.moduleListDropdown = [];
    for (let i = 0; i < this.dropDownDataForModule.length; i++) {
      this.moduleListDropdown = this.moduleListDropdown.concat({
        valueExp: this.dropDownDataForModule[i].codelistCode,
        displayExp: this.dropDownDataForModule[i].codelistName
      });

      if (i == this.dropDownDataForModule.length - 1) {
        this.moduleListDropdown.push({
          valueExp: "Common",
          displayExp: "Common"
        });
      }
    }
  }

  focusmethod(value: any) {
    setTimeout(() => {
      let requiredElement = document.getElementById(value);
      requiredElement?.focus();
    }, 0)
  }

  focusSearch(value: any) {
    setTimeout(() => {
      let searchBox = document.getElementById(value);
      searchBox?.focus();
    }, 0)
  }

  mainModulesearchTxt: any;

  onMainModulesSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (event.source._selected) {
        this.isProcessing = true;
        if (item) {
          this.selectedMainModule = item.valueExp;
          setTimeout(() => {
            this.getcallMethod();
          }, 500);
          this.searchingByDesignationCode = null;
          this.appService.getdistinctCodeListsGroup(item.valueExp).subscribe({
            next: (response: any) => {
              this.codelistGroupList = response;
              this.selectBoxeForDesignationCode();
              this.isProcessing = false;
            }, error: (error) => {
              this.isProcessing = false
            }
          });
        } else {
          this.searchingByDesignationCode = null;
          this.visibleDataGrid = false;
          this.getcallMethod();
          this.appService.getdistinctCodeListsGroup(this.selectedMainModule ?? undefined).subscribe({
            next: (response: any) => {
              this.codelistGroupList = response;
              this.selectBoxeForDesignationCode();
              this.isProcessing = false;
            }, error: (error) => {
              this.isProcessing = false;
            }
          });
        }
      } else {
        this.selectedMainModule = undefined;
        this.isProcessing = false;
      }
      this.isProcessing = false;
    }

  }

  modulesearchTxt: any;

  onModuleSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (event.source._selected) {
        if (item) {
          this.selectedModule = item.valueExp;
        }
      } else {
        this.selectedModule = undefined;
      }
    }

  }

  sortedColumn: string = '';
  sortDirection: string = 'asc';
  sortColumn(column: string, list: any) {
    if (column === this.sortedColumn) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortedColumn = column;
      this.sortDirection = 'asc';
    }
    list.showsort = this.sortDirection;

    this.oneQmsUsersDataForTable1.sort((a: { [x: string]: any; }, b: { [x: string]: any; }) => {
      const key = column;
      const valueA = a[key];
      const valueB = b[key];

      if (valueA! < valueB!) {
        return this.sortDirection === 'asc' ? -1 : 1;
      } else if (valueA! > valueB!) {
        return this.sortDirection === 'asc' ? 1 : -1;
      } else {
        return 0;
      }
    });
    this.setPage(1, 0);
  }

  @ViewChild(DynamicAuditTrailComponent) dynamicAuditTrailComponent!: DynamicAuditTrailComponent;

  openAuditTrail(viewType: any, notification: any) {
    if (this.searchingByDesignationCode) this.auditTrail.codelist_Group_Audit_Trail = this.searchingByDesignationCode;
    this.auditTrail.refNo = viewType == 'overAll' ? null : notification.CODELIST_CODE;
    this.auditTrail.gridName = 'CODELISTS';
    this.auditTrail.report_And_Popup_Name = 'CodeLists Audit Trail';
    this.dynamicAuditTrailComponent.triggerTrail(notification);
  }

  @ViewChild(ExcelPdfComponent) excelPdfComponent!: ExcelPdfComponent;
  excelPdf: any = {};
  reportObj: any = {};

  openReport(reportType: string) {
    this.excelPdf.reportObj = this.reportObj;
    this.excelPdf.reportType = 'Dynamic';
    this.excelPdf.reportName = 'CodeLists Report';
    this.excelPdf.dropDown = this.columnLists?.fieldColumnarray?.map((item: any) => item.fieldColumnarray);
    this.excelPdfComponent.openReportPopup(reportType);
  }

  @ViewChild(GridReorderComponent) gridReorderComponent!: GridReorderComponent;
  openReorder() {
    this.gridReorderComponent.reordercall(this.reportObj.gridName, this.reportObj.tableOrViewName, null, 0)
  }

  onChildValueEmitted() {
    this.getcallMethod();
  };
}
